import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import "./updateprofile.css";
import { Authme, handleUpdateProfile, handleUpdatepassword, showToast } from "../Utils/utils"
import Loaderspinner from "../../components/Loader";

const UpdateProfile = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [profileLoading, setProfileLoading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);

  const [showSidebar, setShowSidebar] = useState(false);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const response = await Authme();
        setFirstName(response?.data?.first_name || "");
        setLastName(response?.data?.last_name || "");
        setEmail(response?.data?.email || "");
      } catch (error) {
        console.error(error, "error...");
      }
    };
    loadProfile();
  }, []);

  const UpdateProfileDetails = async (e) => {
    e.preventDefault();
    try {
      setProfileLoading(true);
      const response = await handleUpdateProfile({ first_name: firstName, last_name: lastName, email });
      showToast(response.message, "success");
    } catch (error) {
      console.log(error, "error...");
      showToast(error.message)
    } finally {
      setProfileLoading(false);
    }
  };

  const UpdatePassword = async (e) => {
    e.preventDefault();
    try {
      setPasswordLoading(true);
      const response = await handleUpdatepassword({
        current_password: currentPassword,
        password: password,
        confirm_password: confirmPassword
      });
      showToast(response.message, "success");
      setCurrentPassword("");
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.log(error, "error...");
      showToast(error.message)
    } finally {
      setPasswordLoading(false);
    }
  };

  const loading = profileLoading || passwordLoading;

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div>
              <div className="header header-bg pb-6">
                <div className="container-fluid">
                  <div className="header-body">
                    <div className="row align-items-center py-4">
                      <div className="col-lg-6 col-7">
                        <nav
                          aria-label="breadcrumb"
                          className="d-none d-md-inline-block ml-md-4"
                        >
                          <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                            <li className="breadcrumb-item">
                              <Link to="/dashboard">
                                <i className="fas fa-home" />
                              </Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/update-profile"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Update Profile</span></Link>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid mt--6">
                <div className="row">
                  <div className="col">
                    <form className="card mb-4" onSubmit={UpdateProfileDetails}>
                      <div className="card-header">
                        <h5 className="mb-0">Profile</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                First Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="First Name"
                                onChange={(e) => setFirstName(e.target.value)}
                                value={firstName}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                Last Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                onChange={(e) => setLastName(e.target.value)}
                                value={lastName}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                Email
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                              />
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn submit-btn mt-4"
                          type="submit"
                        >
                          {" "}
                          <i className="far fa-paper-plane" /> Save Profile{" "}
                        </button>
                      </div>
                    </form>

                    <form className="card mb-4" onSubmit={UpdatePassword}>
                      <div className="card-header">
                        <h5 className="mb-0">Password</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                Current Password
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Current Password"
                                onChange={(e) =>
                                  setCurrentPassword(e.target.value)
                                }
                                value={currentPassword}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                New Password
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder="New Password"
                                onChange={(e) => setPassword(e.target.value)}
                                value={password}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                Confirm Password
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Confirm Password"
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                value={confirmPassword}
                              />
                            </div>
                          </div>
                        </div>

                        <button
                          className="btn submit-btn mt-4"
                          type="submit"
                        >
                          {" "}
                          <i className="far fa-paper-plane" /> Save Password{" "}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default UpdateProfile;
